export default __webpack_public_path__ + "static/media/hht1_direction_animation.b88a70df.png";